export default "/048cb1f2b29308e18768c65cfd51e426596a830c/c149c2995e67c98d8198109bf15793c7.svg";